import { CommonModule, NgOptimizedImage } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import {
  MAT_RADIO_DEFAULT_OPTIONS,
  MatRadioModule,
} from "@angular/material/radio";
import { MatTooltipModule } from "@angular/material/tooltip";
import {
  CariButtonComponent,
  CariInputComponent,
  CariInputContainerComponent,
  CariInputErrorComponent,
  CariLabelComponent,
  CPasswordStrengthIndicatorComponent,
  LinkButtonComponent,
  UIComponentsModule,
  CariLabelHintComponent,
} from "@cariloop/ui-components";
import { TranslateModule } from "@ngx-translate/core";
import { PipesModule } from "app/pipes/pipes.module";
import { ExistingBackupContactComponent } from "app/register/backup-contact/existing/existing-backup-contact.component";
import { EligibilityCheckComponent } from "app/register/eligibility-check/eligibility-check.component";
import { AccountCreationComponent } from "./account-creation/account-creation.component";
import { BackupContactComponent } from "./backup-contact/backup-contact.component";
import { CompleteComponent } from "./complete/complete.component";
import { EmailVerificationComponent } from "./email-verification/email-verification.component";
import { RegisterLayoutComponent } from "./register-layout/register-layout.component";
import { RegisterRoutesModule } from "./register-routes.module";
import { RegisterComponent } from "./register.component";
import {
  RegistrationHeaderComponent,
  RegistrationHeaderLogoComponent,
  RegistrationHeaderStepCounterComponent,
} from "./registration-header/registration-header.component";
import { SsoErrorComponent } from "./sso-error/sso-error.component";
import { IntroductionComponent } from "./introduction/introduction.component";
import { MobileIntroductionComponent } from "./introduction/mobile-introduction/mobile-introduction.component";
import { DesktopIntroductionComponent } from "./introduction/desktop-introduction/desktop-introduction.component";
import { TwoStepVerificationComponent } from "./two-step-verification/two-step-verification.component";
import { LangDropdownComponent } from "app/shared/components/lang-dropdown/lang-dropdown.component";

@NgModule({
  declarations: [
    RegisterComponent,
    EligibilityCheckComponent,
    RegistrationHeaderComponent,
    RegistrationHeaderLogoComponent,
    RegistrationHeaderStepCounterComponent,
    AccountCreationComponent,
    EmailVerificationComponent,
    CompleteComponent,
    ExistingBackupContactComponent,
    SsoErrorComponent,
    IntroductionComponent,
    MobileIntroductionComponent,
    DesktopIntroductionComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    UIComponentsModule,
    CPasswordStrengthIndicatorComponent,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatInputModule,
    PipesModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatRadioModule,
    RegisterRoutesModule,
    MatProgressSpinnerModule,
    NgOptimizedImage,
    RegisterLayoutComponent,
    LinkButtonComponent,
    CariButtonComponent,
    CariInputComponent,
    CariInputContainerComponent,
    CariInputErrorComponent,
    CariLabelComponent,
    CariLabelHintComponent,
    LangDropdownComponent,
    BackupContactComponent,
    TwoStepVerificationComponent,
  ],
  providers: [
    {
      provide: MAT_RADIO_DEFAULT_OPTIONS,
      useValue: { color: "primary" },
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    RegisterLayoutComponent,
    RegistrationHeaderComponent,
    EmailVerificationComponent,
    AccountCreationComponent,
    RegistrationHeaderLogoComponent,
  ],
})
export class RegisterModule {}
